<template>
    <IconConfigProvider size="18px" class="icon-config">
        <div id="app" ref="app">
            <router-view></router-view>
        </div>
    </IconConfigProvider>
</template>

<script>
import { IconConfigProvider } from '@v2icons/utils';
import { mapState, mapMutations } from 'vuex';
import _ from 'lodash'
export default {
    components: {
        IconConfigProvider
    },
    computed: {
        ...mapState(['themeColor'])
    },
    watch: {
        themeColor(newValue) {
            const app = document.getElementById('app');
            app.style.setProperty('--theme-color', newValue);
        }
    },
    methods: {
        ...mapMutations(['setTheme']),
    },
    mounted() {
        const app = document.getElementById('app');
        app.style.setProperty('--theme-color', this.themeColor);

        if (sessionStorage.getItem('store')) {
            let store = sessionStorage.getItem('store');
            this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(store)));
        }

        //在页面刷新时将vuex里的信息保存到sessionStorage里
        window.addEventListener('beforeunload', () => {
            sessionStorage.setItem('store', JSON.stringify(this.$store.state));
        });
         this.$nextTick(() => {
      const $app = this.$refs.app;
      // 设置 屏幕 百分比 尺寸 适配
      const standardScale = "100%" / "100%";

      window.addEventListener(
        "resize",
        _.debounce(function () {
          const docHeight = document.body.clientHeight;
          const docWidth = document.body.clientWidth;

          if (docWidth < 1680) {
            const currentScale = docHeight / docWidth;
            let [scale, translate] = [0, 0];
            if (currentScale < standardScale) {
              // 以高度计算
              scale = docHeight / 1080;
              const shouleWidth = 1920 * scale;
         
              const offsetWidth = docWidth - shouleWidth;
              translate =
                offsetWidth > 0 ? `translate(${offsetWidth / 2}px, 0)` : "";
            } else {
              // 以宽度计算
              scale = docWidth / 1920;
              const shouleHeight = 1080 * scale;
              const offsetHeight = docHeight - shouleHeight;
              translate =
                offsetHeight > 0 ? `translate(0, ${offsetHeight / 2}px)` : "";
            }
            console.log(translate);
        //     $app.style.cssText = `
        //     transform: scale(${scale}) ${translate};
        //     transform-origin: top left;
        //     min-width: 1920px;
        //     min-height: 1080px;
        //   `;
          } else {
            $app.style.cssText = "";
          }
        }),
        300
      );

      if (document.createEvent) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent("resize", true, true);
        window.dispatchEvent(event);
      } else if (document.createEventObject) {
        window.fireEvent("onresize");
      }
    });
    }
};









</script>
<!--
.el-menu {
    background-color: var(--theme-color) !important;
}
-->
<style lang="scss">
@import './assets/css/main.css';
@import './assets/css/global.css';

#app {
    --theme-color: #ffff;
}

.header {
    background-color: var(--theme-color);
    // background-color: red;
}

.login-wrap {
    background: var(--theme-color);
}

.el-menu {
    background-color: #222222;
}
.tags-li.active {
    border: 1px solid var(--theme-color);
    background-color: var(--theme-color);
}

.collapse-btn:hover {
    background: var(--theme-color);
}

//修改 el-table 固定列样式问题
.el-table {
    .el-table__fixed { // 左固定列
        height: auto !important;
        bottom: 18px; // 改为自动高度后，设置与父容器的底部距离，高度会动态改变，值可以设置比滚动条的高度稍微大一些
    }
    .el-table__fixed-right { // 右固定列
        height: 100% !important;
        bottom: 18px; // 改为自动高度后，设置与父容器的底部距离，高度会动态改变，值可以设置比滚动条的高度稍微大一些
    }
}
</style>
